import React, { useRef, useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { LineGraph } from "./GraphData";

am4core.useTheme(am4themes_animated);
const DateBasedLine = (props) => {
  const chart = useRef(null);

  useLayoutEffect(() => {
    let x = am4core.create(
      props.divId ? props.divId : "LineGrapheDivID",
      am4charts.XYChart
    );
    x.background.fill = "#2F3640";
    x.background.opacity = 0.5;
    if (LineGraph) {
      
      //title
      var title = x.titles.create();
      title.text = props.title;
      title.fontSize = 25;
      title.marginBottom = 30;
      title.fill = "#b1b0b5";

      // Create axes
      var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = props.category
        ? props.category
        : "date";
      categoryAxis.renderer.minGridDistance = 30;
      // categoryAxis.renderer.labels.template.rotation = 45;
      categoryAxis.renderer.labels.template.horizontalCenter = "left";
      categoryAxis.renderer.labels.template.fontSize = 11;
      categoryAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      categoryAxis.renderer.line.strokeOpacity = 0.2;
      categoryAxis.renderer.line.strokeWidth = 1;
      categoryAxis.renderer.line.stroke = am4core.color("#000");
      categoryAxis.renderer.labels.template.rotation = 45;

      var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.labels.template.fontSize = 11;
      valueAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      valueAxis.renderer.line.strokeOpacity = 0.2;
      valueAxis.renderer.line.strokeWidth = 1;
      valueAxis.renderer.line.stroke = am4core.color("#000");

      // Create series
      var series = x.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "value";
      series.dataFields.categoryX = "date";
      series.tooltipText = "{value}";
      series.strokeWidth = 3;
      series.name = props.lineOneValue;
      series.minBulletDistance = 15;
      series.yAxis = valueAxis;
      series.stroke = props.lineOneColor
        ? am4core.color(props.lineOneColor)
        : "#6794DC";
      series.fill = props.lineOneColor
        ? am4core.color(props.lineOneColor)
        : "#6794DC";
      series.legendSettings.labelText = "[{stroke}]{name}[/]";

      // Add legend
      x.legend = new am4charts.Legend();
      x.legend.fill = "#b1b0b5";

      // Make a panning cursor
      x.cursor = new am4charts.XYCursor();
      x.cursor.behavior = "panXY";
      x.cursor.xAxis = categoryAxis;
      x.cursor.snapToSeries = series;

      x.data = LineGraph;

      const scrollbarX = new am4core.Scrollbar();
      scrollbarX.marginBottom = 20;
      x.scrollbarX = scrollbarX;

      chart.current = x;
    }
    return () => {
      x.dispose();
    };
  }, [LineGraph]);

  return (
    <div className="App">
      <div
        id={props.divId ? props.divId : "LineGrapheDivID"}
        style={{ width: "100%", height: "350px" }}
      ></div>
    </div>
  );
};

export default DateBasedLine;
